import store, {persistor} from '@/redux'
import ConfigProvider from '../AndtConfigProvider'
import {ReactNode} from 'react'
import ReactDOM, {Root} from 'react-dom/client'
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'

export default function render2Body(id: string, component: ReactNode): Root {
	let div: HTMLDivElement | null = null
	let root: Root | null = null
	div = document.createElement('div')
	const oldElement = document.getElementById(id)
	oldElement && oldElement.remove()
	div.setAttribute('id', id)
	document.body.appendChild(div)
	root = ReactDOM.createRoot(document.getElementById(id) as HTMLElement)
	// root.render(component)
	root.render(
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<ConfigProvider>{component}</ConfigProvider>
			</PersistGate>
		</Provider>
	)
	return root
}
